module.exports = __webpack_public_path__ + "img/shop11.78bdba1a.jpg";